import React from "react"
import Card from "@react/shared/ui/Card"

// Formats a Money amount rendered by the server as { cents, currency_symbol }.
export const formatMoney = (cents, symbol) => {
  if (cents == null || isNaN(cents)) return "—"
  return `${(cents / 100).toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${symbol || "€"}`
}

const formatCoef = c =>
  c == null || isNaN(c)
    ? "—"
    : `×${c.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

const formatPct = p => (p == null || isNaN(p) ? "—" : `${p.toFixed(1).replace(".", ",")}%`)

// 4-card library-wide summary strip. Values are pre-computed server-side
// (Quotes::QlineGroups::SetParams#stats) and shipped as plain JSON so we
// don't reimplement the Money math client-side.
const StatsStrip = ({ stats }) => {
  const cells = [
    { label: I18n.t("quotes.qline_service_blueprints.stats.services_label"),    value: String(stats.count),                                      sub: I18n.t("quotes.qline_service_blueprints.stats.services_sub") },
    { label: I18n.t("quotes.qline_service_blueprints.stats.avg_sale_label"),    value: formatMoney(stats.avg_sale_cents, stats.currency_symbol), sub: I18n.t("quotes.qline_service_blueprints.stats.avg_sale_sub") },
    { label: I18n.t("quotes.qline_service_blueprints.stats.avg_coef_label"),    value: formatCoef(stats.avg_coef),                               sub: I18n.t("quotes.qline_service_blueprints.stats.avg_coef_sub") },
    { label: I18n.t("quotes.qline_service_blueprints.stats.avg_margin_label"),  value: formatPct(stats.avg_margin_pct),                          sub: I18n.t("quotes.qline_service_blueprints.stats.avg_margin_sub") },
  ]

  return (
    <div className="grid grid-cols-4 gap-3 mb-6">
      {cells.map(c => (
        <Card key={c.label} padding="md" className="rounded-lg">
          <div className="text-xs text-slate-500">{c.label}</div>
          <div className="text-xl font-semibold text-slate-900 tabular-nums mt-1">{c.value}</div>
          <div className="text-xs text-slate-400 mt-1">{c.sub}</div>
        </Card>
      ))}
    </div>
  )
}

export default StatsStrip
